module.exports = __webpack_public_path__ + "img/4.26e0fb59.jpg";